import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderState } from './loader';

@Injectable()
export class LoaderService {

  private loaderSubject = new Subject<LoaderState>();

  loaderState = this.loaderSubject.asObservable();

  public secondLoderShow = new Subject<any>();
  public secondLoderHide = new Subject<any>();
  constructor() { }

  show(type: string) {
    this.loaderSubject.next(<LoaderState>{ show: true });
  }

  hide() {
    this.loaderSubject.next(<LoaderState>{ show: false });
  }

  showSecond(type: string) {
    this.secondLoderShow.next(true);
  }

  hideSecond() {
    this.secondLoderHide.next(true);
  }
}
